import { FormlyFieldTable } from "./../../../../libs/vadmin/vforms/src/lib/field-types/table/table.type";
import { FormlyFieldIMask } from "./../../../../libs/vadmin/vforms/src/lib/field-types/masked-text-field/masked-text-field.type";
import { APP_INITIALIZER, LOCALE_ID, NgModule, CUSTOM_ELEMENTS_SCHEMA, DEFAULT_CURRENCY_CODE } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { RouterModule, Routes } from "@angular/router";
import "hammerjs";
import { SharedModule } from "@shared/shared.module";
import { BrowserModule, HammerModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FuseProgressBarModule, FuseSidebarModule } from "@fuse/components";
import { LayoutModule } from "./layout/layout.module";
import { FuseSharedModule } from "@fuse/shared.module";
import { API_BASE_URL } from "@shared/api/service-proxies";
import { FuseModule } from "@fuse/fuse.module";
import { fuseConfig } from "./fuse-config";
import { ServiceProxyModule } from "@shared/api/service-proxy.module";
import { TranslateModule } from "@ngx-translate/core";
import { AppConsts } from "@shared/AppConsts";
import { AppComponent } from "app/app.component";
import localePt from "@angular/common/locales/pt";
import { registerLocaleData } from "@angular/common";
import { PasswordMatchValidatorDirective } from "@app/wapps/core/password.match.directive";
import { MatGoogleMapsAutocompleteModule } from "@angular-material-extensions/google-maps-autocomplete";
import { ImageCropperComponent } from "ngx-image-cropper";
import { MomentModule } from "ngx-moment";
import { NgxDnDModule } from "@swimlane/ngx-dnd";
import { FacebookPixelService } from "@app/FacebookPixelService";
import { AbpModule } from "abp-ng2-module";
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { AppInitializer } from "../app-initializer";
import { CommonModule } from "@angular/common";
import { IMaskModule } from "angular-imask";
import { UsersService } from "./wapps/system/users/users.service";
import { UrlHistoryService } from "./wapps/core/url-history.service";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { ReactiveFormsModule } from "@angular/forms";
import { FormlyModule } from "@ngx-formly/core";
import { FormlyMaterialModule } from "@ngx-formly/material";
import { PendingTermsOfServiceSignatureModule } from "@app/wapps/legal/pending-terms-of-service/pending-terms-of-service-signature.module";
import { InsightsModule } from "@app/monitoring.module";
import { AudioService } from "@app/audio.service";
import { environment } from "../environments/environment";
import { GoogleTagManagerModule } from "angular-google-tag-manager";
import { HtmlInjectorService } from "@app/HtmlInjectorService";
import { MomentLocaleService } from "@app/moment-locale.service";
import { TranslocoCoreModule } from "@i18n";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { StoreRouterConnectingModule } from "@ngrx/router-store";
import { FuseConfigModule, FuseScrollbarModule } from "@nx-workspace/fuse";
import { FuseModule as FuseV2Module } from "@nx-workspace/fuse";
import { UiNotifyModule } from "@ui/notify";
import { STATISTICS_API_BASE_URL } from "@dashboard-statistics";
import { LEGACY_API_BASE_URL, SESSION_COOKIE_NAME } from "@api";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { SMART_FORMS_API_BASE_URL } from "@vhealth/engage";
import { VuiModule } from "@vui";
import { NotificationService } from "./wapps/notification/notification.service";
import { GeocodeService } from "./wapps/core/address/geocode.service";
import { GoogleMapsLoaderService } from "./wapps/core/maps-api-loader.service";
import { GoogleMapsModule } from "@angular/google-maps";
import { MAT_TABS_CONFIG } from "@angular/material/tabs";
import { SUBSCRIPTION_API_BASE_URL } from "libs/subscription/src/api/proxies";
import { EmailValidator } from "libs/vadmin/vforms/src/lib/formly/model";
import { FormlyCid10Component } from "libs/vadmin/vforms/src/lib/field-types/cid10/formly/formly-cid10.component";
import { FormlyApiSelectSearchComponent } from "libs/vadmin/vforms/src/lib/field-types/api-select-search/formly/formly-api-select-search.component";
import { Cid10Type } from "libs/vadmin/vforms/src/lib/field-types/cid10/cid10";
import { ApiSelectSearchType } from "libs/vadmin/vforms/src/lib/field-types/api-select-search/api-select-search";
import { FileUploaderType } from "libs/vadmin/vforms/src/lib/field-types/file-uploader/file-uploader";
import { TimePickerType } from "libs/vadmin/vforms/src/lib/field-types/time-picker/time-picker";
import { FormlyFieldFileUploaderComponent } from "libs/vadmin/vforms/src/lib/field-types/file-uploader/formly/formly-file-uploader.component";
import { TimePickerComponent } from "libs/vadmin/vforms/src/lib/field-types/time-picker/time-picker.component";
import { FormlyMatDatepickerModule } from "@ngx-formly/material/datepicker";
import { FormlyFieldIcon } from "libs/vadmin/vforms/src/lib/field-types/icon/icon.component";
import { RepeatTypeComponent } from "libs/vadmin/vforms/src/lib/field-types/repeat/repeat-section.type";
import { RepeatTypeComponentV2 } from "libs/vadmin/vforms/src/lib/field-types/repeat-v2/repeat-section-v2.type";
import { FormlyFieldTabs } from "libs/vadmin/vforms/src/lib/field-types/tabs/tabs.type";
import { FormlyFieldToggleView } from "libs/vadmin/vforms/src/lib/field-types/toggle-view/toggle-view.type";
import { RepeatInlineTypeComponent } from "../../../../libs/vadmin/vforms/src/lib/field-types/repeat-inline/repeat-inline.type";
import {
    dateNotInFutureValidationMessage,
    dateNotInFutureValidator,
    dumAndDppOrderValidator,
    minItemsValidationMessage,
    minItemsValidator,
} from "libs/vadmin/vforms/src/lib/validators";
import { OutputFieldType } from "libs/vadmin/vforms/src/lib/field-types/output/output.type";
import { FormlyFieldFileUploaderV2Component } from "libs/vadmin/vforms/src/lib/field-types/file-uploader/formly/v2/formly-file-uploader.component";

export const DD_MM_YYYY_Format = {
    parse: {
        dateInput: "LL",
    },
    display: {
        dateInput: "DD/MM/YYYY",
        monthYearLabel: "MMM YYYY",
        dateA11yLabel: "LL",
        monthYearA11yLabel: "MMMM YYYY",
    },
};

const appRoutes: Routes = [
    {
        path: "",
        loadChildren: () => import("./wapps/wapps.module").then((m) => m.WappsModule),
        data: { preload: true },
    },
];

export function getRemoteServiceBaseUrl(): string {
    AppConsts.appBaseUrl = location.origin;
    let apiUrl = environment.api_url;

    if (apiUrl?.length === 0) {
        if (!document.location.origin) {
            const port = document.location.port ? ":" + document.location.port : "";
            apiUrl = document.location.protocol + "//" + document.location.hostname + port;
        } else {
            apiUrl = document.location.origin;
        }
    }

    AppConsts.remoteServiceBaseUrl = apiUrl;

    return AppConsts.remoteServiceBaseUrl;
}

export function getCurrentLanguage(): string {
    return abp.localization.currentLanguage.name;
}

export function getRemoteStatisticsApiBaseUrl(): string {
    let baseUrl = "";
    if (environment.statistics_api_url !== undefined) {
        baseUrl = environment.statistics_api_url;
    } else {
        if (!document.location.origin) {
            const port = document.location.port ? ":" + document.location.port : "";
            baseUrl = document.location.protocol + "//" + document.location.hostname + port;
        } else {
            baseUrl = document.location.origin;
        }
    }
    return baseUrl;
}

export function getRemoteSubscriptionApiBaseUrl(): string {
    let baseUrl = "";
    if (environment.subscription_api_url !== undefined) {
        baseUrl = environment.subscription_api_url;
    } else {
        if (!document.location.origin) {
            const port = document.location.port ? ":" + document.location.port : "";
            baseUrl = document.location.protocol + "//" + document.location.hostname + port;
        } else {
            baseUrl = document.location.origin;
        }
    }
    return baseUrl;
}

registerLocaleData(localePt);

@NgModule({
    declarations: [AppComponent, PasswordMatchValidatorDirective],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes, { enableTracing: false }),
        NgxDnDModule.forRoot(),
        TranslateModule.forRoot(),
        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        StoreModule.forRoot({}),
        EffectsModule.forRoot([]),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        LayoutModule,
        //abp
        SharedModule.forRoot(),
        AbpModule,
        ServiceProxyModule,
        ImageCropperComponent,

        MatGoogleMapsAutocompleteModule,
        MomentModule,
        IMaskModule,
        ReactiveFormsModule,
        FormlyMaterialModule,
        FormlyMatDatepickerModule,
        FormlyMatDatepickerModule,
        FormlyModule.forRoot({
            validators: [
                { name: "email", validation: EmailValidator },
                { name: "minItems", validation: minItemsValidator },
                { name: "dateOrder", validation: dumAndDppOrderValidator },
                { name: "dateNotInFuture", validation: dateNotInFutureValidator },
            ],
            types: [
                { name: "repeat", component: RepeatTypeComponent },
                { name: "repeat-v2", component: RepeatTypeComponentV2 },
                { name: "repeat-inline", component: RepeatInlineTypeComponent },
                { name: "tabs", component: FormlyFieldTabs },
                { name: "icon", component: FormlyFieldIcon },
                { name: "v2-tabs", component: FormlyFieldToggleView },
                { name: Cid10Type.Id, component: FormlyCid10Component },
                { name: ApiSelectSearchType.Id, component: FormlyApiSelectSearchComponent },
                { name: FileUploaderType.Id, component: FormlyFieldFileUploaderComponent },
                { name: "files-v2", component: FormlyFieldFileUploaderV2Component },
                { name: TimePickerType.Id, component: TimePickerComponent },
                { name: "imask", component: FormlyFieldIMask },
                { name: "output", component: OutputFieldType },
                { name: "table", component: FormlyFieldTable },
            ],
            extras: {
                resetFieldOnHide: true,
            },
            validationMessages: [
                { name: "required", message: "Campo obrigatório" },
                { name: "email", message: "E-mail inválido" },
                { name: "minItems", message: minItemsValidationMessage },
                { name: "dateOrder", message: "DUM deve ser anterior à DPP." },
                { name: "dateNotInFuture", message: dateNotInFutureValidationMessage },
            ],
        }),
        PendingTermsOfServiceSignatureModule,
        InsightsModule,

        GoogleMapsModule,
        GoogleTagManagerModule.forRoot({
            id: environment.gtmId,
        }),
        FuseV2Module,
        FuseConfigModule.forRoot({
            layout: "dense",
            scheme: "light",
            theme: "default",
            screens: {
                sm: "320px",
                md: "768px",
                lg: "1366px",
                xl: "1441px",
            },
        }),
        FuseScrollbarModule,
        TranslocoCoreModule,
        UiNotifyModule,
        VuiModule,

        // 3rd party modules that require global configuration via forRoot
        !environment.production ? StoreDevtoolsModule.instrument() : [],
        StoreRouterConnectingModule.forRoot(),
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        HammerModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [RouterModule],
    providers: [
        UrlHistoryService,
        UsersService,
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: "outline",
                floatLabel: "auto",
                subscriptSizing: "dynamic",
                hideRequiredMarker: false,
            },
        },
        { provide: DEFAULT_CURRENCY_CODE, useValue: "R$" },
        { provide: MAT_DATE_LOCALE, useValue: "pt-BR" },
        { provide: MAT_DATE_FORMATS, useValue: DD_MM_YYYY_Format },
        {
            provide: MAT_TABS_CONFIG,
            useValue: {
                paginationEnabled: true,
                animationDuration: "300ms",
            },
        },
        { provide: API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
        {
            provide: APP_INITIALIZER,
            useFactory: (appInitializer: AppInitializer) => appInitializer.init(),
            deps: [AppInitializer],
            multi: true,
        },
        {
            provide: LOCALE_ID,
            useFactory: getCurrentLanguage,
        },
        FacebookPixelService,
        AudioService,
        HtmlInjectorService,
        MomentLocaleService,
        { provide: STATISTICS_API_BASE_URL, useFactory: getRemoteStatisticsApiBaseUrl },
        { provide: SESSION_COOKIE_NAME, useValue: "Abp.AuthToken" },
        { provide: LEGACY_API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
        { provide: SMART_FORMS_API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
        { provide: SUBSCRIPTION_API_BASE_URL, useFactory: getRemoteSubscriptionApiBaseUrl },
        NotificationService,
        GeocodeService,
        GoogleMapsLoaderService,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
    constructor() {}
}
